/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap, map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/observable/throw';
import * as CryptoJS from 'crypto-js';
import * as PBKDF2 from 'crypto-js';
import { LoginConfig, userTypes } from './login.config';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';

@Injectable()
export class LoginService extends LoginConfig {
    private SALT_SIZE = 128 / 8;
    private KEY_SIZE = 512 / 32;
    private UsersStore = "Users";

    private Base64: any = { _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", c1: 0, c2: 0, c3: 0, encode: function (e) { var t = ""; var n, r, i, s, o, u, a; var f = 0; e = this._utf8_encode(e); while (f < e.length) { n = e.charCodeAt(f++); r = e.charCodeAt(f++); i = e.charCodeAt(f++); s = n >> 2; o = (n & 3) << 4 | r >> 4; u = (r & 15) << 2 | i >> 6; a = i & 63; if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 } t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a) } return t }, decode: function (e) { var t = ""; var n, r, i; var s, o, u, a; var f = 0; e = e.replace(/[^A-Za-z0-9+/=]/g, ""); while (f < e.length) { s = this._keyStr.indexOf(e.charAt(f++)); o = this._keyStr.indexOf(e.charAt(f++)); u = this._keyStr.indexOf(e.charAt(f++)); a = this._keyStr.indexOf(e.charAt(f++)); n = s << 2 | o >> 4; r = (o & 15) << 4 | u >> 2; i = (u & 3) << 6 | a; t = t + String.fromCharCode(n); if (u != 64) { t = t + String.fromCharCode(r) } if (a != 64) { t = t + String.fromCharCode(i) } } t = this._utf8_decode(t); return t }, _utf8_encode: function (e) { e = e.replace(/rn/g, "n"); var t = ""; for (var n = 0; n < e.length; n++) { var r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) { t += String.fromCharCode(r >> 6 | 192); t += String.fromCharCode(r & 63 | 128) } else { t += String.fromCharCode(r >> 12 | 224); t += String.fromCharCode(r >> 6 & 63 | 128); t += String.fromCharCode(r & 63 | 128) } } return t }, _utf8_decode: function (e) { var t = ""; var n = 0; var r = this.c1 = this.c2 = 0; while (n < e.length) { r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); n++ } else if (r > 191 && r < 224) { this.c2 = e.charCodeAt(n + 1); t += String.fromCharCode((r & 31) << 6 | this.c2 & 63); n += 2 } else { this.c2 = e.charCodeAt(n + 1); this.c3 = e.charCodeAt(n + 2); t += String.fromCharCode((r & 15) << 12 | (this.c2 & 63) << 6 | this.c3 & 63); n += 3 } } return t } };

    constructor(private http: HttpClient) {
        super();
    }

  public getBase64(): any { return this.Base64; }
    public isdefined(obj) { return obj != null && typeof obj !== 'undefined'; }
    private isundefined(obj) { return obj == null || typeof obj === 'undefined'; } 
    private ToObject(json) { if (json == null || json.length == 0) return null; return JSON.parse(json); }
    private ToJson(obj) { if (obj == null) return ""; return JSON.stringify(obj); }
    private GenerateSalt(explicitIterations) { return CryptoJS.lib.WordArray.random(this.SALT_SIZE); }
    private HashSessionCode(value, salt) { var key = CryptoJS.PBKDF2(value, salt, { "keySize": this.KEY_SIZE }); return key.toString(CryptoJS.enc.Base64); }
    private Encrypt(key, txt) { if (txt == null || txt.length == 0) return ""; return CryptoJS.AES.encrypt(txt, key == null ? navigator.userAgent : key).toString(); }
    private Decrypt(key, txt) { if (txt == null || txt.length == 0) return ""; try { return CryptoJS.AES.decrypt(txt, key == null ? navigator.userAgent : key).toString(CryptoJS.enc.Utf8); } catch (e) { console.log(e); return null; } }
    private ResetUserDetails(dtls) { sessionStorage.setItem("UserDetails", dtls); return sessionStorage.getItem("UserDetails"); }
    private ResetCode(code) { sessionStorage.setItem("Code", code); return sessionStorage.getItem("Code"); }
    private GetCode() { return sessionStorage.getItem("Code"); }
    private ResetCS(cs) { sessionStorage.setItem("CS", cs); return sessionStorage.getItem("CS"); }
    private GetCS() { if (sessionStorage.getItem("CS") == null || sessionStorage.getItem("CS").length == 0) { sessionStorage.setItem("CS", this.Encrypt(this.client_id, this.client_s)); } return sessionStorage.getItem("CS"); }
    public GetLoginUrl(responsetype: string, state?: string) { if (responsetype == null || responsetype.length == 0) responsetype = 'code'; var uri = this.AddQueryString(this.identity_authorizeUri, {
        'client_id': this.client_id,
        'redirect_uri': this.identity_redirectUrl,
        'state': 'Identity',
        'scope': this.identity_token_scope,
        'response_type': responsetype,
    }); return uri; }

    public AddQueryString(uri, parameters) { if (uri == null || uri.length == 0) return null; if (parameters == null || parameters.length == 0) return uri;
        var delimiter = (uri.indexOf('?') == -1) ? '?' : '&';
        for (var parameterName in parameters) {
            var parameterValue = parameters[parameterName];
            uri += delimiter + encodeURIComponent(parameterName) + '=' + encodeURIComponent(parameterValue);
            delimiter = '&';
        }
        return uri;
    }

    public DoLoginComplete(response: any, redirectUrl?: string) {
        if (response == null) {
            console.log("No data is login response.");
            return;
        }

        var tokenobject = null;
        if (this.isdefined(response["data"]))
            tokenobject = response.data;
        else
            tokenobject = response;

        if (tokenobject == null) {
            console.log("Invalid token structure.");
            console.log("Login completed but failed to process!");
            return;
        }

        var UserDetails = {
            Username: tokenobject["UserName"],
            Name: tokenobject["Name"],
            SignedIn: true,
            Token: tokenobject
        };

        this.ResetCode("");

        this.InitProfiles();
        this.UpdateUserProfile(tokenobject["UserName"]);
        console.log("Login completed and successful!");

        this.ResetUserDetails(this.Encrypt(null, this.ToJson(UserDetails)));
        let succeeded: boolean = UserDetails != null;
        if (succeeded)
          console.log("Login completed and successful!");
        else
          console.log("Login completed but failed to process!");

        return this.PostLoginComplete(UserDetails, redirectUrl);
    }

    private DoLogin(restype) {
        if (restype == 'code') {
            this.ResetCode("");
            this.ResetUserDetails("");
        }

        window.location.replace(this.GetLoginUrl(restype));
    }

    public DoGrantAuth(cltId, cltSecret, authCode, redirectUrl?: string): Observable<any> {
        if (cltId == null || cltId.length == 0
            || authCode == null || authCode.length == 0
            || cltSecret == null || cltSecret.length == 0) {
            if (cltSecret == null || cltSecret.length == 0) {
                cltSecret = this.client_s;
            }
            else {
                console.log("Invalid parameters in DoGrantAuth.");
                return Observable.throw({ errorCode: 0, errorMessage: "Invalid parameters in DoGrantAuth."});
            }
        }

        var tokenreqdata = 'client_id' + "=" + cltId
            + '&redirect_uri=' + encodeURIComponent(this.identity_redirectUrl) + '&grant_type=authorization_code' + '&code=' + authCode;

        this.ResetCS(this.Encrypt(cltId, cltSecret));

        var auth = 'Basic ' + this.Base64.encode(cltId + ":" + cltSecret);

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'text/plain',
                'Authorization': auth
            })
        };

        return this.http.post(
            this.identity_tokenUri,
            tokenreqdata,
            httpOptions
        )
        .pipe(
            tap(
                response => this.DoLoginComplete(response, redirectUrl),
                error => {
                if (error != null) {
                    console.log(JSON.stringify(error));
                    if (!this.isundefined(error.status)) {
                        switch (error.status) {
                            case 400: {
                                this.DoLogin('code');
                                break;
                            }
                        }
                    }
                }
            })
        );
    }

    private InitProfiles() {
        if (this.GetProfileCount(null) == 0) {
            var userstore = {};
            localStorage.setItem(this.UsersStore, this.ToJson(userstore));
        }
    }

    private GetProfiles() {
        var users = localStorage.getItem(this.UsersStore);
        if (users != null && users.length > 0) {
            return this.ToObject(users);
        }
        return null;
    }

    private GetProfileCount(usrs) {
        if (usrs == null)
            usrs = this.GetProfiles();

        var size = 0;
        if (usrs != null) {
            for (var key in usrs) {
                if (usrs.hasOwnProperty(key)) size++;
            }
        }
        return size;
    }

    private UpdateUserProfile(uid) {
        if (uid == null || uid.length == 0)
            return false;

        var username = uid.toLowerCase();
        var users = localStorage.getItem(this.UsersStore);
        if (users != null && users.length > 0) {
            var userstore = JSON.parse(users);
            if (userstore != null) {
                var up = userstore[username];
                if (up != null) {
                    up["LastLogin"] = sessionStorage.getItem("UserDetails");
                    localStorage.setItem(this.UsersStore, JSON.stringify(userstore));
                }
                else {
                    var localprofile = {};
                    localprofile["username"] = uid;
                    localprofile["LastLogin"] = sessionStorage.getItem("UserDetails");
                    userstore[uid.toLowerCase()] = localprofile;
                    localStorage.setItem(this.UsersStore, this.ToJson(userstore));
                }
            }
        }

        return true;
    }

    public GetAccessToken(usrInfo) {
        if (usrInfo == null || usrInfo.Token == null)
            return "";

        if (usrInfo.Token["access_token"] == null || usrInfo.Token["access_token"].length == 0)
            return "";

        return usrInfo.Token["access_token"];
    }

    private GetTokenExpires(usrInfo) {
        if (usrInfo == null || usrInfo.Token == null)
            return "";

        if (usrInfo.Token[".expires"] == null || usrInfo.Token[".expires"].length == 0)
            return "";

        let exp = null;
        try {
            exp = new Date(usrInfo.Token[".expires"]);
        }
        catch (e) {
            // To do logger
        }
        return exp;
    }

    private GetTokenIssued(usrInfo) {
        if (usrInfo == null || usrInfo.Token == null)
            return "";

        if (usrInfo.Token[".issued"] == null || usrInfo.Token[".issued"].length == 0)
            return "";

        let exp = null;
        try {
            exp = new Date(usrInfo.Token[".issued"]);
        }
        catch (e) {
            // To do logger
        }
        return exp;
    }

    public ParseParams(url) {
        if (url == null || url.length == 0)
            return {};

        var regex = /[?&#]([^=#]+)=([^&#]*)/g;
        var params = {};
        var match = null;
        while (match = regex.exec(url)) {
            var k = match[1];
            var v = match[2];
            if (k != null){
                let qpos = k.indexOf("?");
                if (qpos >= 0 && qpos < k.length - 1)
                    k = k.substring(qpos + 1);
                else if (k.indexOf("/") >= 0)
                    k = k.substring(1);

                params[k] = v;
            }
        }
        return params;
    }

    public GetParams() {
        return this.ParseParams(window.location.href);
    };

  public setMainAppChildMode(mode: boolean): void {
    return sessionStorage.setItem("mainappChildMode", mode ? "1" : "0");
  }

    public OnLoginCallback(data): Observable<any> {
        if (data == null) {
            return Observable.throw("Invalid login callback parameter.");
        }

      let failsafeParams = this.ParseParams(window.location.href);
      let code = data["code"];
      if ((typeof code === 'undefined' || code == null || code.length == 0) && failsafeParams != null)
        code = failsafeParams["code"];

      let redirectUrl: string = null;
      if (failsafeParams != null) {
        redirectUrl = failsafeParams["redirect"];
      }

      let suid = data["suid"];
      if ((typeof suid === 'undefined' || suid == null || suid.length == 0) && failsafeParams != null)
        suid = failsafeParams["suid"];

      let sact = data["sact"];
      if ((typeof sact === 'undefined' || sact == null || sact.length == 0) && failsafeParams != null)
        sact = failsafeParams["sact"];

      let sacttype = data["sacttype"];
      if ((typeof sacttype === 'undefined' || sacttype == null || sacttype.length == 0) && failsafeParams != null)
        sacttype = failsafeParams["sacttype"];

      let sptact = data["sptact"];
      if ((typeof sptact === 'undefined' || sptact == null || sptact.length == 0) && failsafeParams != null)
        sptact = failsafeParams["sptact"];

      let childmode = data["childmode"];
      if ((typeof childmode === 'undefined' || childmode == null || childmode.length == 0) && failsafeParams != null)
        childmode = failsafeParams["childmode"];

      if (code != null) {
        return this.DoGrantAuth(this.client_id, this.Decrypt(this.client_id, this.GetCS()), code, redirectUrl);
      }
      else if (suid != null) {
        return this.OnUserSession(suid, sact, sacttype, sptact, redirectUrl, childmode);
      }
      return Observable.throw("Callback paramter not supported.");
    }

    OnUserSession(suid: string, sact: string, sacttype: string, sptact: string, redirectUrl: string, cmode: string): Observable<any> {
      if (suid == null || suid.length == 0) return Observable.throw('Invalid username parameter.');
      
      let orig_suid = suid;
      let usrInfo = this.GetSessionUserInfo();
      let dtExp = this.GetTokenExpires(usrInfo);
      let tokenInvalid = (dtExp != null && dtExp.constructor.name == "String" && dtExp == "") || (dtExp != null && dtExp.constructor.name == "Date" && Iceutility.GetLocalDate() >= dtExp);
      
      if (false == tokenInvalid && usrInfo != null && usrInfo.Token != null && usrInfo.Token["access_token"] != null && this.IsSignedIn(usrInfo)) {
        if (this.IsSignedIn(usrInfo)) {
          // Domain and domain type open here
          if (sact != null && sact.length > 0 && sacttype != null && sacttype.length > 0) {
            sessionStorage.setItem("g_currentact", decodeURIComponent(sact));
            sessionStorage.setItem("g_currentacttype", sacttype);
          }

          if (sptact != null && sptact.length > 0) {
            sessionStorage.setItem("g_currentpatient", decodeURIComponent(sptact));
          }

          if (cmode != null && cmode.length > 0) {
            this.setMainAppChildMode(cmode == "1");
          }
          return this.PostLoginComplete(usrInfo, decodeURIComponent(redirectUrl));
        }
      }
      else {
        let uid = this.ConvertUsernName(decodeURIComponent(orig_suid));
        let localprofile = this.GetUserProfile(uid);
        if (localprofile != null) {
          let lstlogin = localprofile["LastLogin"];
          if (lstlogin != null && lstlogin.length > 0) {
            usrInfo = this.GetLastLogon(lstlogin);
            if (this.IsSignedIn(usrInfo)) {
              this.ResetUserDetails(this.Encrypt(null, this.ToJson(usrInfo)));
              if (sact != null && sact.length > 0 && sacttype != null && sacttype.length > 0) {
                sessionStorage.setItem("g_currentact", decodeURIComponent(sact));
                sessionStorage.setItem("g_currentacttype", sacttype);
              }
              return this.PostLoginComplete(usrInfo, decodeURIComponent(redirectUrl));
            }
          }
        }
      }

      return this.ValidateUserInfo(usrInfo).pipe(
        tap(
          response => this.DoLoginComplete(response, redirectUrl),
          error => {
            if (error != null)
              console.log(JSON.stringify(error));

            this.DoLogin('code');
          })
      );
    }

    private ValidateUserInfo(usrInfo: any): Observable<any> {
      if (usrInfo == null) {
        return Observable.throw("Invalid user information parameter.");
      }

      var token = this.GetAccessToken(usrInfo);
      if (token == null || token.length == 0) {
        let msg = "Access Token required to continue.";
        console.log(msg);
        return Observable.throw(msg);
      }

      console.log("Token issued on: " + this.GetTokenIssued(usrInfo));

      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + token
        })
      };

      return this.http.get(
        this.identity_userInfoUri,
        httpOptions);
    }

    private GetLastLogon(incomingUserDtls: string) {
      if (incomingUserDtls == null || incomingUserDtls.length == 0)
        return null;

      return this.ToObject(this.Decrypt(null, incomingUserDtls));
    }

    private ConvertUsernName(encUserName: string): string {
      if (encUserName == null || encUserName.length == 0)
        return "";

      return this.Decrypt(null, encUserName);
    }

    public PostLoginComplete(userInfo: any, redirectUrl?: string): Observable<any> {
      if (userInfo == null || userInfo.UserId == 0) {
        return Observable.throw('Invalid user information.');
      }

      // Moved the dateformat up above the redirect
      if (userInfo != null && userInfo["Token"] != null) {
        this.currentDateFormat = this.getLocaleFromCountryCode(userInfo["Token"].COUNTRY_ID);
      }
      else {
        this.currentDateFormat = Iceutility.getDateFormat(IceTypes.DATE_FORMATS.mm_dd_yyyy);
      }
      sessionStorage.setItem("g_currentdateformat", this.currentDateFormat);

      if (redirectUrl != null) {
        window.location.href = redirectUrl;
      }
      else if (sessionStorage.loginCompleteUrl != null && sessionStorage.loginCompleteUrl.length > 0) {
        let loginComplete = sessionStorage.loginCompleteUrl;
        window.location.href = loginComplete;
        sessionStorage.loginCompleteUrl = "";
      }
      else {
        window.location.href = this.identity_loginCompleteUri;
      }
      return Observable.of('Post Login Complete!');
    }

    public hasDomainType(usrInfo, domaintype: IceTypes.ACCOUNT_TYPE): boolean {
      if (usrInfo == null || usrInfo.Token == null)
        return false;

      try {
        let acs = this.ToObject(usrInfo.Token.Access);
        if (acs == null)
          throw "Error: Invalid access";
        
        return acs[domaintype] != null && acs[domaintype].length > 0;
      }
      catch (e) {
        console.log(e);
      }
      return false;
    }

    private findDomain(usrInfo, domain: string) {
      let item = null;
      if (usrInfo == null || usrInfo.Token == null)
        return item;


      if (domain == null || domain.length == 0)
        return item;

      try {
        let acs = this.ToObject(usrInfo.Token.Access);
        if (acs == null)
          throw "Error: Invalid access";

        item = acs[domain];
      }
      catch (e) {
        item = null;
        console.log(e);
      }
      return item;
    }

    private parsePermission(per: string) {
      let ret = {
        ug: userTypes.USER_GROUPS.upUNK,
        fea: userTypes.USER_FEATURES.ufNone,
        ufa: userTypes.USER_FEATURE_ACCESS.ufaNone
      };

      if (per == null || per.length == 0)
        return null;

      let temp = "";
      for (let i = 0; i < per.length; i++) {
        let ch = per[i];
        temp += ch;
        if (i == 1) {
          try {
            ret.ug = parseInt(temp);
          }
          catch
          {
            return null;
          }
        }
        else if (i == 4) {
          try {
            ret.fea = parseInt(temp.substr(2, 3));
          }
          catch
          {
            return null;
          }
        }
        else if (i == 5) {
          try {
            let ac = temp[temp.length - 1];
            ret.ufa = parseInt(ac);
          }
          catch
          {
            return null;
          }
        }
      }

      return ret;
    }

    // Local Login
    public Authorize(up, code, signinuser) {
        if (up == null || code == null || code.length == 0)
            return false;

        if (up["scode"] == null || up["scode"].length == 0)
            return false;

        var uid = up["username"].toLowerCase();
        var slttext = this.Decrypt(uid, up["slt"]);
        if (slttext == null || slttext.length == 0)
            return false;

        try {
            var slt = this.ToObject(slttext);
            if (this.HashSessionCode(code, slt) === up["scode"]) {
                if (signinuser == true) {
                    var name = '';
                    var token = null;
                    var lastlogintxt = up["LastLogin"];
                    if (lastlogintxt != null && lastlogintxt.length > 0) {
                        var lastlogin = this.ToObject(this.Decrypt(navigator.userAgent, lastlogintxt));
                        if (lastlogin != null && lastlogin["Username"] != null && lastlogin["Username"].toLowerCase() == uid) {
                            name = lastlogin["Name"];
                            token = lastlogin["Token"];
                        }
                    }

                    var usrInfoReset = {
                        Username: uid,
                        Name: name,
                        Token: token,
                        SignedIn: true
                    };

                    this.ResetUserDetails(this.Encrypt(navigator.userAgent, this.ToJson(usrInfoReset)));
                }
                return true;
            }
        }
        catch (e) {
            console.log(e);
        }
        return false;
    }

    public ServiceLogin = function () {
        this.DoLogin('code');
    }

    public ServiceLoginUrl = function () {
        this.GetLoginUrl('code');
    }

    public ServiceRegistrationLoginUrl() {
        var params = encodeURIComponent(this.GetLoginUrl('code'));
        return this.identity_registrationUri + "?ReturnUrl=" + params;
    };

    public ServiceLogout(usrInfo): Observable<any> {
        let deferred: Observable<any> = Observable.create();

        if (usrInfo == null || usrInfo.Token == null) {
            return deferred.pipe(
                tap( // Log the result or error
                    data => data,
                    error => {
                        if (error != null)
                            console.log(JSON.stringify(error));
                    })
                );
        }

        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + usrInfo.Token["access_token"]
            })
        };

        return this.http.get(
            this.identity_signoutUri,
            httpOptions);
    }

    public SessionLogout(skipUI?: boolean) {
        var usrInfo = this.ToObject(this.Decrypt(null, sessionStorage.getItem("UserDetails")));
        if (usrInfo == null)
            return false;

        if (navigator.onLine == false || (skipUI != null && skipUI == true)) {
            var usrInfoReset = {
                Username: '',
                Name: '',
                Token: null,
                SignedIn: false
            };

          this.ResetUserDetails(this.Encrypt(null, this.ToJson(usrInfoReset)));
          return false;
        }
        else {
          var usrInfoReset = {
              Username: '',
              Name: '',
              Token: null,
              SignedIn: false
          };

          this.ResetUserDetails(this.Encrypt(null, this.ToJson(usrInfoReset)));

          setTimeout(() => {
            let soutin = this.AddQueryString(this.identity_ui_signoutUri, {
              'ReturnUrl': encodeURIComponent(this.GetLoginUrl('code'))
            });

            location.replace(soutin);
          });
        }
      sessionStorage.clear();
      return true;
    };

    public GetServiceProfile(usrInfo): Observable<any> {
        let deferred: Observable<any> = Observable.create();
        if (usrInfo == null) {
            return deferred.pipe(
                tap( // Log the result or error
                    data => data,
                    error => {
                        console.log("No User info found in Profile.");
                    })
            );
        }

        var token = this.GetAccessToken(usrInfo);
        if (token == null || token.length == 0) {
            return deferred.pipe(
                tap( // Log the result or error
                    data => data,
                    error => {
                        console.log("No Token for Service Profile.");
                    })
            );
        }

        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + usrInfo.Token["access_token"]
            })
        };

        return this.http.get(
            this.identity_userInfoUri,
            httpOptions);
    }

    public GetUserName(usrInfo, encrypt: boolean): string {
      if (usrInfo == null)
        return "";

      if (encrypt == true) {
        return this.Encrypt(null, usrInfo.Username);
      }
      return usrInfo.Username;
    }

    // User Session Info Members
    public GetSessionUserInfo() {
        return this.ToObject(this.Decrypt(navigator.userAgent, sessionStorage.getItem("UserDetails")));
    }

    public GetUserInfo = function (incomingUserDtls) {
        if (incomingUserDtls == null || incomingUserDtls.length == 0)
            return null;

        return this.ToObject(this.Decrypt(navigator.userAgent, incomingUserDtls));
    }

    public GetLastSignedInUser() {
        // Get the token of the last user on the system
        var lastuser = null;
        var lastissued = null;
        var profiles = this.GetProfiles();
        if (profiles != null) {
            for (var usr in profiles) {
                var u = profiles[usr];
                if (u == null)
                    continue;

                var this_userInfo = this.GetUserInfo(u["LastLogin"]);
                if (this_userInfo != null && this_userInfo.Token != null) {
                    if (this_userInfo.UserId == null || this_userInfo.UserId.length == 0 || this_userInfo.UserId == 0)
                        continue;

                    var issued = null;
                    try {
                        issued = new Date(this_userInfo.Token[".issued"]);
                        if (lastissued == null || issued.getTime() > lastissued.getTime()) {
                            lastissued = issued;
                            lastuser = this_userInfo;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
        }
        return lastuser;
    }

    // Status Members
    public IsSignedIn(usrInfo) {
        if (usrInfo != null && this.isdefined(usrInfo["SignedIn"]))
            return usrInfo["SignedIn"];

        return false;
    }

    // User Profile
    public GetUserProfile(uid) {
        if (uid == null || uid.length == 0) return null;

        var username = uid.toLowerCase();
        var users = localStorage.getItem(this.UsersStore);
        if (users != null && users.length > 0) {
            var userstore = this.ToObject(users);
            if (userstore != null) {
                return userstore[username];
            }
        }
        return null;
    }

    public RemoveUserProfile(uid) {
        if (uid == null || uid.length == 0) return null;

        try {
            var username = uid.toLowerCase();
            var users = localStorage.getItem(this.UsersStore);
            if (users != null && users.length > 0) {
                var userstore = this.ToObject(users);
                if (userstore != null) {
                    var up = userstore[username];
                    if (up != null) {
                        delete userstore[username];
                        localStorage.setItem(this.UsersStore, this.ToJson(userstore));
                    }
                }
            }
            return true;
        }
        catch (e) {
            console.log(e);
        }
        return false;
    }

    SetUserSessionCode = function (uid, sessioncode) {
        if (uid == null || uid.length == 0) return;

        var localprofile = this.GetUserProfile(uid);
        if (localprofile == null)
            localprofile = {};

        var salt = this.GenerateSalt();
        var hashedsessioncode = this.HashSessionCode(sessioncode, salt);

        localprofile["username"] = uid;
        localprofile["slt"] = this.Encrypt(uid.toLowerCase(), this.ToJson(salt));
        localprofile["scode"] = hashedsessioncode;

        var userstore = null;
        var users = localStorage.getItem(this.UsersStore);
        if (users != null && users.length > 0)
            userstore = this.ToObject(users);

        if (userstore == null)
            userstore = {};

        // Remove Invalid profiles
        var removeusers = [];
        for (var usr in userstore) {
            var u = userstore[usr];
            if (u == null)
                continue;

            var userInfo = this.GetUserInfo(u["LastLogin"]);
            if (userInfo == null || userInfo.UserId == null || userInfo.UserId == 0 || userInfo.UserId.length == 0) {
                try {
                    if (this.isdefined(this.DefaultUser)) {
                        if (this.DefaultUser != u.username)
                            removeusers.push(usr); // consider this an unverified user
                    }
                } catch (e) { }
            }
        }

        for (var remidx = 0; remidx < removeusers.length; remidx++) {
            try {
                delete userstore[removeusers[remidx]];
            } catch (e) {
                console.log(e);
            }
        }

        userstore[uid.toLowerCase()] = localprofile;
        localStorage.setItem(this.UsersStore, this.ToJson(userstore));
    };

    public InitializeProfiles() {
        this.InitProfiles();
    };

    HasTokenExpired(incomingUserInfo) {
        var usrInfo = null;
        if (incomingUserInfo == null) {
            usrInfo = this.ToObject(this.Decrypt(null, sessionStorage.getItem("UserDetails")));
        }
        else {
            usrInfo = incomingUserInfo;
        }

        var exp = this.GetTokenExpires(usrInfo);
        try {
            if (new Date() >= exp) return true;
        }
        catch (e) {
            // To do logger
        }
        return false;
    }

    public RefreshToken(usrInfo): Observable<any> {
        var token = "";
        if (usrInfo != null && usrInfo.Token != null && usrInfo.Token["refresh_token"] != null)
            token = usrInfo.Token["refresh_token"];

        var tokenreqdata = 'client_id' + "=" + this.client_id
            + '&grant_type=refresh_token' + '&refresh_token' + "=" + token;

        var auth = 'Basic ' + this.Base64.encode(this.client_id + ":" + this.Decrypt(this.GetCS(), this.client_id));

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'text/plain',
                'Authorization': auth
            })
        };

        return this.http.post(
            this.identity_tokenUri,
            tokenreqdata,
            httpOptions
        ).pipe(
            tap(
                response => this.DoLoginComplete(response),
                error => {
                if (error != null) {
                    console.log(JSON.stringify(error));
                }
            }));
    }

    public getFeatureAccess(userInfo, domain, fea) {
      let feaaccess = userTypes.USER_FEATURE_ACCESS.ufaNone;

      if (userInfo == null)
        return feaaccess;

      if (domain == null || domain.length == 0)
        return feaaccess;

      let domainAccess = this.findDomain(userInfo, domain);
      if (domainAccess == null)
        return feaaccess;

      for (let nIndex = 0; nIndex < domainAccess.length; nIndex++) {
        let thisitem = domainAccess[nIndex];
        if (thisitem != null && thisitem.length > 0) {
          let test = this.parsePermission(thisitem);
          if (test != null && test.fea == fea) {
            feaaccess = test.ufa;
            /*
            if (memberAccess != null && domain != null && domain.length > 0) {
                let exceptionAccess = memberAccess["exception_" + domain];
                permissionobject.USER_FEATURE_ACCESS excaccessufa;
                if (getexceptionaccess(act_type, act, fea, out excaccessufa)) {
                    feaaccess = excaccessufa;
                }
            }
            */
            break;
          }
        }
      }
      return feaaccess;
    }

    getHighestGroup(userInfo, domain) {
      let grps = userTypes.USER_GROUPS.upUNK;
      if (userInfo == null)
        return grps;

      let domainAccess = this.findDomain(userInfo, domain);
      if (domainAccess == null) return grps;

      for (let nIndex = 0; nIndex < domainAccess.length; nIndex++) {
        let thisitem = domainAccess[nIndex];
        if (thisitem != null && thisitem.length > 0) {
          let test = this.parsePermission(thisitem);
          if (test != null && test.ug > grps) {
            grps = test.ug;
          }
        }
      }
      return grps;
    }

    public isMemberOf(userInfo, domain, ug) {
      let domainAccess = this.findDomain(userInfo, domain);
      if (domainAccess == null) return false;

      for (let thisitem in domainAccess) {
        let test = this.parsePermission(thisitem);
        if (test != null && test.ug == ug) {
          return true;
        }
      }
      return false;
    }

  public getPrivateNetworkUri(act: string, acttype: IceTypes.ACCOUNT_TYPE, actorigin: string, acttypeorigin: IceTypes.ACCOUNT_TYPE, newtab: boolean): string {
    try {
      let usrInfo = this.GetSessionUserInfo();
      if (this.IsSignedIn(usrInfo)) {
        return this.identity_PrivateNetworkUri + "?domaintype=" + acttype.toString() + "&domain=" + act + "&domaintypeorigin=" + acttypeorigin.toString() + "&domainorigin=" + actorigin;
      }
    }
    catch (e) {
      console.log(e);
    }
    return "";
  }

  public doPrivateNetwork(act: string, acttype: IceTypes.ACCOUNT_TYPE, actorigin: string, acttypeorigin: IceTypes.ACCOUNT_TYPE, newtab: boolean): void {
    try {
      let usrInfo = this.GetSessionUserInfo();
      if (this.IsSignedIn(usrInfo)) {
        let url = this.identity_PrivateNetworkUri + "?domaintype=" + acttype.toString() + "&domain=" + act + "&domaintypeorigin=" + acttypeorigin.toString() + "&domainorigin=" + actorigin;
        if (newtab)
          window.open(url, "_blank");
        else
          location.href = url;
      }
    }
    catch (e) {
      console.log(e);
    }
  }
  
  public doWLRegister(returnUrl: string, caption: string, ro: any, newtab: boolean): void {
    try {
      let usrInfo = this.GetSessionUserInfo();
      if (false == this.IsSignedIn(usrInfo)) { // only if not signed in
        if (ro == null) {
          // To do log error
          return;
        }
        let roText = this.Encrypt(null, this.ToJson(ro));
        let url = this.identity_wlRegistrationUri + "?returnUrl=" + encodeURIComponent(returnUrl) + "&caption=" + encodeURIComponent(caption) + "&ro=" + encodeURIComponent(roText); 
        if (newtab)
          window.open(url, "_blank");
        else
          location.href = url;
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  public doRegisterMember(act: string, acttype: IceTypes.ACCOUNT_TYPE, actOrigin: string, acttypeOrigin: IceTypes.ACCOUNT_TYPE, newtab: boolean): void {
    try {
      let usrInfo = this.GetSessionUserInfo();
      if (this.IsSignedIn(usrInfo)) {
        let url = this.identity_RegisterMemberUri + "&domaintype=" + acttype.toString() + "&domain=" + act + "&domaintypeorigin=" + acttypeOrigin.toString() + "&domainorigin=" + actOrigin; //"https://qa-login.networknowehr.com/clientoauth/Register?returnurl=%2fclientoauth%2fauthorize%3fclient_id%3dice1%26redirect_uri%3dhttps%253a%252f%252fqa.networknowehr.com%252fhome%252findex%26state%3didentity%26scope%3dhttps%253a%252f%252fqa-api.networknowehr.com%252fapi%26response_type%3dcode" + "&domaintype=" + acttype.toString() + "&domain=" + act;
        if (newtab)
          window.open(url, "_blank");
        else
          location.href = url;
      }      
    }
    catch (e) {
      console.log(e);
    }
  }

  public getLocaleFromCountryCode(countryCode) {
    let dateFormat = "";

    if (!Iceutility.isStringUndefinedNullOrEmpty(countryCode)) {
      let languageMap = IceTypes.LanguageMap[countryCode];
      if (languageMap) {
        dateFormat = languageMap.dateFormat;
      } else {
        dateFormat = Iceutility.getDateFormat(IceTypes.DATE_FORMATS.dd_mm_yyyy); // defaulted to dd/mm/yyyy if the country is not present in the map
      }
    } else {
      dateFormat = Iceutility.getDateFormat(IceTypes.DATE_FORMATS.mm_dd_yyyy);
    }

    return dateFormat;
  }
}
